import * as React from 'preact/compat'
import SVG from './SVG'
import styles from '../../css/article.pcss.json'
import cn from 'classnames'
import { wait } from '../common/helpers'

export default ({ children, onClose, header, parentEl }: {
  children: React.JSX.Element,
  onClose: () => void,
  header: string,
  parentEl: HTMLSpanElement
}) => {
  const [shown, setShown] = React.useState(false)
  const container = React.useRef<HTMLDivElement>()

  const close = React.useMemo(() => {
    return async () => {
      setShown(false)
      await wait(200)
      onClose()
    }
  }, [onClose])

  const outsideClickHandler = React.useMemo(() => {
    return (e: MouseEvent) => {
      if (e.target instanceof Element && e.target.closest(`.${styles['sidenote']}`)) {
        return
      }
      // noinspection JSIgnoredPromiseFromCall
      close()
    }
  }, [close])

  React.useEffect(() => {
    setShown(true)
    window.addEventListener('scroll', close)
    window.addEventListener('click', outsideClickHandler)

    return () => {
      window.removeEventListener('scroll', close)
      window.removeEventListener('click', outsideClickHandler)
    }
  }, [])

  let sidenoteTop = parentEl.getBoundingClientRect().top
  if (container.current && sidenoteTop + container.current.offsetHeight > window.innerHeight) {
    sidenoteTop = window.innerHeight - (16 + container.current.offsetHeight)
  }

  return <div className={styles['sidenote-container']}>
    <div className={styles['sidenote-container__inner']}>
      <div
        ref={container}
        className={cn({
          [styles['sidenote']]: true,
          [styles['sidenote--shown']]: shown,
        })}
        style={`--sidenote-top: ${sidenoteTop}px`}
      >
        <button type='button' className={styles['sidenote-close']} onClick={close}>
          <SVG i='sg-new/cross' adaptive/>
        </button>
        <p className={styles['sidenote-header']}>{header}</p>
        {children}
      </div>
    </div>
  </div>
}
